export default __webpack_public_path__ + "static/media/robot.f9f5f0db.png";